import { render } from "./TopBanner.vue?vue&type=template&id=8b3ca558&scoped=true"
import script from "./TopBanner.vue?vue&type=script&lang=js"
export * from "./TopBanner.vue?vue&type=script&lang=js"

import "./TopBanner.vue?vue&type=style&index=0&id=8b3ca558&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3ca558"]])

export default __exports__